import { render, staticRenderFns } from "./sync-diagnosis.vue?vue&type=template&id=1c161294&scoped=true"
import script from "./sync-diagnosis.vue?vue&type=script&lang=js"
export * from "./sync-diagnosis.vue?vue&type=script&lang=js"
import style0 from "./sync-diagnosis.vue?vue&type=style&index=0&id=1c161294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c161294",
  null
  
)

export default component.exports